import { motion } from "motion/react";

import type { DragDestination, DragSource } from "../context/DragProvider";

export function DropPreview({ source, preview }: { preview: DragDestination; source: DragSource }) {
  let order = preview.row;
  if (preview.column === source.column) {
    if (preview.row < source.row) {
      order -= 1;
    }
  } else {
    order -= 1;
  }

  return (
    <motion.div
      layout="position"
      data-drag-placeholder
      aria-hidden
      style={{
        height: source.height,
        width: source.width,
        order,
      }}
      className="shrink-0 rounded-sm border-2 border-dashed border-divider bg-black/5"
    />
  );
}
